// react
import React, { PropTypes } from "react"
import { connect } from "react-redux"
// material-ui
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton"
// app
import { list } from "actions/ref/actions.js"


class OptionGroup extends React.Component {
    constructor(props) {
        super()

        this.onChange = (e, value) => this.props.onChange(value)
    }

    componentDidMount() {
        if (!this.props.reference) this.props.list()
    }

    render() {
        const buttons = []
        let i = 0

        if (this.props.reference && this.props.reference.has("data")) {
            this.props.reference.get("data").forEach(item => {
                buttons.push(
                    <RadioButton
                        key={ i++ }
                        label={ item.text }
                        value={ item.text } 
                    />
                )
            })
        }

        return (
            <RadioButtonGroup
                name={ this.props.table }
                defaultSelected={ this.props.value }
                onChange={ this.onChange }
            >
                { buttons }
            </RadioButtonGroup>
        )
    }
}

OptionGroup.propTypes = {
    table: PropTypes.string.isRequired,
    reference: PropTypes.object,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onError: PropTypes.func
}

const mapStateToProps = (state, ownProps) => {
    return {
        reference: state.ref.get(ownProps.table)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        list: () => dispatch(list(ownProps.table))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OptionGroup)


/** WEBPACK FOOTER **
 ** ./src/containers/OptionGroup/optiongroup.js
 **/